import React, { ReactElement, FC, Fragment } from 'react';
import { Box, Theme, Typography } from '@mui/material';
import { createStyles, withStyles, WithStyles, WithTheme } from '@mui/styles';

import { inject, observer } from 'mobx-react';
import { Services } from 'helpers';
import StoreModel from 'models/Index';

interface HeaderProps extends WithStyles<typeof styles>, WithTheme {}

interface HeaderPropsInjected extends HeaderProps {
    Store: StoreModel;
}

const styles = (theme: Theme) =>
    createStyles({
        container: {
            width: 300,
            height: '100%',
            display: 'flex',
        },
        defaultLogo: {
            padding: '44px 15px 44px 15px',
            height: '100%',
            maxWidth: '100%',
        },
        title: {
            fontSize: '2.5rem',
            margin: '24px 48px 32px 0',
            fontFamily: 'Montserrat',
            alignSelf: 'center',
        },
    });

const Header: FC<HeaderProps> = (props): ReactElement => {
    const { Store, classes } = props as HeaderPropsInjected;
    return (
        <Fragment>
            <Box className={classes.container}>
                <img
                    className={classes.defaultLogo}
                    src={Store.kioskLogo}
                    alt={'logo'}
                />
            </Box>
            <Typography className={classes.title}>Admin Mode</Typography>
        </Fragment>
    );
};

export default inject(Services.STORE)(
    withStyles(styles, { withTheme: true })(observer(Header))
);
